import { Selector } from '@ngxs/store';
import { AppStateModel } from './app.model';
import { AppState } from './app.state';

export class AppStateSelectors {

    @Selector([AppState])
    static getProduct(state: AppStateModel) {
        return state.product;
    }
    @Selector([AppState])
    static isProcessing(state: AppStateModel) {
        return state.isProcessing;
    }
    @Selector([AppState])
    static isAuthenticated(state: AppStateModel) {
        return state.isAuthenticated;
    }

    @Selector([AppState])
    static isTagNotFound(state: AppStateModel) {
        return state.isTagNotFound;
    }

    @Selector([AppState])
    static getQRCode(state: AppStateModel) {
        return state.qrCode;
    }

    @Selector([AppState])
    static getTenantId(state: AppStateModel) {
        return state.tenantId;
    }

    @Selector([AppState])
    static getDownloadFilePath(state: AppStateModel) {
        return state.downloadFilePath;
    }

    @Selector([AppState])
    static getPublicScanResults(state: AppStateModel) {
        return state.publicScanResults;
    }
}